import type { Segment, Track, Waypoint } from '@/types/tour'

function normalizePointTime(time: unknown): number | undefined {
  if (typeof time === 'number' && Number.isFinite(time)) {
    return time
  }

  if (typeof time === 'string' && time.length > 0) {
    const numericTime = Number(time)
    if (Number.isFinite(numericTime)) {
      return numericTime
    }

    const parsedTime = new Date(time).getTime()
    if (Number.isFinite(parsedTime)) {
      return parsedTime
    }
  }

  return undefined
}

function hydrateApiSegmentPoint(
  point: Partial<Waypoint> & Pick<Waypoint, 'lat' | 'lon'>,
  segmentClientId: string,
  index: number,
): Waypoint {
  const normalizedTime = normalizePointTime((point as Waypoint & { time?: unknown }).time)

  return {
    ...point,
    time: normalizedTime,
    clientId: point.clientId || `${segmentClientId}-point-${index}`,
  }
}

export function hydrateApiSegments(segments: Track['segments'] | undefined): Segment[] {
  return [...(segments || [])]
    .sort((a, b) => ((a as { order?: number }).order ?? 0) - ((b as { order?: number }).order ?? 0))
    .map((segment, segmentIndex) => {
      const segmentClientId = segment.clientId || `segment-${segmentIndex}`

      return {
        ...segment,
        clientId: segmentClientId,
        points: (segment.points || []).map((point, pointIndex) =>
          hydrateApiSegmentPoint(point, segmentClientId, pointIndex),
        ),
      }
    })
}
